function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// listen for events with target.addEventListener(type, listener[, useCapture])
//   returns false if the event was cancelled by an event listener (Event.preventDefault())
function fireEvent(target_element, event_name, event_detail) {
  var ev = new CustomEvent(event_name, {
    detail: event_detail,
    bubbles: true,
    cancelable: true
  });
  return target_element.dispatchEvent(ev);
}

// Offset to first positioned (not static) ancestor element
function absoluteOffset(elem) {
  var offset = null,
    run_el = elem;
  if (run_el) {
    offset = {
      left: 0,
      top: 0
    };
    do {
      offset.top += run_el.offsetTop;
      offset.left += run_el.offsetLeft;
      run_el = run_el.offsetParent;
    } while (run_el && window.getComputedStyle(run_el).getPropertyValue("position") == 'static');
  }
  return offset;
}
var template = "\n<style>\n  :host {\n    display: inline-block;\n    position: absolute;\n    padding: 7px 0;\n    visibility: hidden;\n    z-index: 99;\n  }\n  :host(.hovering), :host(:hover) { visibility: visible; }\n\n  :host .tip-inner {\n    font-size: small;\n    border: 1px solid #e8e8e8;\n    border-radius: 5px;\n  }\n\n  :host .tip-content { padding: 8px; }\n\n  :host .arrow {\n    width: 0;\n    height: 0;\n    border-width: 0 8px 0 8px;\n    border-style: solid dashed none;\n    position: absolute;\n    border-left-color: transparent;\n    border-right-color: transparent;\n  }\n\n  :host(.bottom) .arrow { border-bottom-width: 8px; border-style: none dashed solid; }\n  :host(.bottom) .arrow-front { top: 2px; }\n  :host(.bottom) .arrow-back { top: 1px; }\n\n  :host(:not(.bottom)) .arrow { border-top-width: 8px; border-style: solid dashed none; }\n  :host(:not(.bottom)) .arrow-front { bottom: 2px; }\n  :host(:not(.bottom)) .arrow-back { bottom: 1px; }\n\n  :host(.left) .arrow { right: 16px; }\n  :host(:not(.left)) .arrow { left: 16px; }\n\n  /* DEFAULT - Skin : white */\n  :host .tip-inner { background: #fff; color: #888; }\n  :host .arrow-front { border-top-color: #fff; border-bottom-color: #fff; }\n  :host .arrow-back { border-top-color: #e8e8e8; border-bottom-color: #e8e8e8; }\n\n    /* Tips - Skin : black */\n  :host(.black) .tip-inner   { background: #000; color: #fff; }\n  :host(.black) .arrow-front { border-top-color: #000; border-bottom-color: #000; }\n  :host(.black) .arrow-back  { border-top-color: #000; border-bottom-color: #000; }\n</style>\n\n<div class=\"tip-inner\">\n  <div class=\"tip-content\">\n    <slot></slot>\n  </div>\n</div>\n<div class=\"arrow arrow-back\"></div>\n<div class=\"arrow arrow-front\"></div>\n";
var TsTooltip = /*#__PURE__*/function (_HTMLElement) {
  function TsTooltip() {
    var _this;
    _classCallCheck(this, TsTooltip);
    _this = _callSuper(this, TsTooltip);
    _this.attachShadow({
      mode: 'open'
    }).innerHTML = template;
    return _this;
  }
  _inherits(TsTooltip, _HTMLElement);
  return _createClass(TsTooltip, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var tip = this;
      this.hoverable = this.previousElementSibling;
      this.hoverable.addEventListener("mouseover", tip._show_deferred.bind(tip));
      this.hoverable.addEventListener("mouseout", tip.hide.bind(tip));

      // clicks inside the tooltip shouldn't bleed out
      this.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.classList.remove('hovering');
      this.show_delay && clearTimeout(this.show_delay); // in case there is a showing pending
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      // allow listeners to prevent content loading
      if (!this.hasAttribute("href") || !this.loaded) {
        if (!fireEvent(this, "ts-tooltip-open")) {
          return false;
        }
      }
      if (this.hasAttribute("href") && !this.loaded) {
        fetch(this.getAttribute('href'), {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (response) {
          return response.text();
        }).then(function (html) {
          _this2.innerHTML = html;
          _this2.loaded = true;
          if (_this2.hoverable.matches(":hover")) {
            // only if we should still show it (loading took time!)
            _this2.show(_this2);
          }
        });
        return; // the Ajax reply will trigger the actual showing of the element
      }
      // show
      this.classList.add('hovering');
      if (this.hasAttribute("always-reload")) {
        this.loaded = false;
      }
      var hoverable_abs_offset = absoluteOffset(this.hoverable),
        hoverable_absolute_scroll = {
          x: 0,
          y: 0
        }; // WC.absolute_scroll(this.hoverable);
      // Set vertical position
      var tip_height = this.offsetHeight,
        top_delta = hoverable_abs_offset.top - hoverable_absolute_scroll.y < tip_height ? this.hoverable.offsetHeight : 0 - tip_height;
      this.style.top = hoverable_abs_offset.top - hoverable_absolute_scroll.y + top_delta + "px";
      this.classList.toggle('bottom', top_delta > 0);

      // Set horizontal position
      var tip_width = this.offsetWidth,
        left_delta = 0;
      // if tip sticks out to the right of the parent rectangle, try to right-align it with hoverable
      if (hoverable_abs_offset.left - hoverable_absolute_scroll.x + tip_width > this.offsetParent.offsetWidth) {
        left_delta = 0 - tip_width + this.hoverable.offsetWidth;
      }
      // if it now sticks out to the left of the parent rectangle, see if it fits on the screen to the right
      if (hoverable_abs_offset.left - hoverable_absolute_scroll.x + left_delta < 0 && this.hoverable.getBoundingClientRect().left + tip_width < document.body.getBoundingClientRect().right) {
        left_delta = 0;
      }
      this.style.left = hoverable_abs_offset.left - hoverable_absolute_scroll.x + left_delta + "px";
      this.classList.toggle('left', left_delta < 0);
    }
  }, {
    key: "_show_deferred",
    value: function _show_deferred() {
      this.show_delay = setTimeout(this.show.bind(this), this.getAttribute("delay") || 0);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
export { TsTooltip };